import closedMutualFunds from '../../data/securities/closedMutualFunds.json';

/**
 * Set of closed mutual fund symbols for quick lookup.
 *
 * Using a Set provides O(1) average-time lookup via `.has()`,
 * which is more efficient than iterating an array with `.includes()`,
 * especially as the list grows.
 */
const CLOSED_MUTUAL_FUNDS = new Set<string>(closedMutualFunds);

/**
 * Hook to determine whether a mutual fund is closed based on its symbol.
 * Returns `undefined` when the symbol is not provided, avoiding an unnecessary lookup.
 */
const useIsMutualFundClosed = (symbol: string | undefined) => {
  if (!symbol) return undefined;
  return CLOSED_MUTUAL_FUNDS.has(symbol);
};

export default useIsMutualFundClosed;
